import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const SDIcon = ({
  children,
  color,
  defaultColorKey,
  overrides,
  ref,
  size = 16,
  title,
  viewBox = '0 0 32 32',
  ...rest
}) => {
  const [, theme] = useStyletron()

  color = color ?? theme.colors[defaultColorKey ?? 'primary']

  return (
    <Icon viewBox={viewBox} ref={ref} title={title} size={size} color={color} overrides={overrides} {...rest}>
      {title && <title>{title}</title>}
      {children}
    </Icon>
  )
}

SDIcon.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  defaultColorKey: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
  viewBox: PropTypes.string,
}

export default SDIcon
